import { BaseModel } from "@blue-chip/core";
import CustomReportDataOption from "./CustomReportDataOption";

export default class CustomReport extends BaseModel {
  static get hasMany() {
    return [CustomReportDataOption];
  }
}
